import request from '@/utils/http';
/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = (fn, t) => {
    let last;
    let timer;
    const interval = t || 500;
    return function () {
        const args = arguments;
        const now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, interval);
        } else {
            last = now;
            fn.apply(this, args);
        }
    };
};

// 标识查询产品列表
export const getProductList = (params) => {
    return request({
        url: '/api-sn/product/searchPageForComplex',
        method: 'post',
        data: params
    });
};

// 查询号段
export const getParagraph = (params) => {
    return request({
        url: `/api-sn/identity/maxNum`,
        method: 'post',
        data: params
    });
};

// 标识生成
export const setRegistered = (params) => {
    return request({
        url: `/api-sn/identity`,
        method: 'post',
        data: params
    });
};

// 标识生成
export const setSNumber = (params) => {
    return request({
        url: `/api-sn/identity/success/${params}`,
        method: 'get'
    });
};